import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=4310a781&scoped=true"
import script from "./DatasetDetail.vue?vue&type=script&lang=js"
export * from "./DatasetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310a781",
  null
  
)

export default component.exports